export default {
    'SEARCH.PAGE.TITLE': 'What are you looking for?',
    'SEARCH.PAGE.INPUT.PLACEHOLDER': 'Type your research here',
};
